import { render } from "./DataSourcesPage.vue?vue&type=template&id=796007af&ts=true"
import script from "./DataSourcesPage.vue?vue&type=script&lang=ts"
export * from "./DataSourcesPage.vue?vue&type=script&lang=ts"

import "./DataSourcesPage.vue?vue&type=style&index=0&id=796007af&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__